/* =========================================================
   Angry Orange — Animation runtime
   - IntersectionObserver to apply .is-in on .reveal-* targets
   - Wraps hero <h1> words in spans for the per-word rise
   - Nav scroll state
   ========================================================= */

(function () {
  function wrapHeroWords() {
    const h1 = document.querySelector('.ao-hero-h1');
    if (!h1 || h1.dataset.aoWrapped === '1') return;
    // Walk all text nodes and wrap each word in a span.word
    const walker = document.createTreeWalker(h1, NodeFilter.SHOW_TEXT, null);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim().length > 0) textNodes.push(node);
    }
    let wordIndex = 0;
    textNodes.forEach(n => {
      const parts = n.nodeValue.split(/(\s+)/);
      const frag = document.createDocumentFragment();
      parts.forEach(p => {
        if (p.trim() === '') {
          frag.appendChild(document.createTextNode(p));
        } else {
          const span = document.createElement('span');
          span.className = 'word';
          span.textContent = p;
          span.style.setProperty('--word-delay', (wordIndex * 80) + 'ms');
          wordIndex += 1;
          frag.appendChild(span);
        }
      });
      n.parentNode.replaceChild(frag, n);
    });
    h1.dataset.aoWrapped = '1';
  }

  function triggerHero() {
    const h1 = document.querySelector('.ao-hero-h1');
    const text = document.querySelector('.ao-hero-text');
    const photo = document.querySelector('.ao-hero-photo');
    if (h1) requestAnimationFrame(() => h1.classList.add('is-in'));
    if (text) requestAnimationFrame(() => text.classList.add('is-in'));
    if (photo) requestAnimationFrame(() => photo.classList.add('is-in'));
  }

  // Auto-decorate sections + children with .reveal classes so we don't
  // need to touch every component file.
  function autoDecorate() {
    // Sections to add reveal on (whole section reveals together)
    const sectionSelectors = [
      '.ao-suspects',
      '.ao-how',
      '.ao-cta',
      '.ao-product-detail',
    ];
    sectionSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => el.classList.add('ao-watch'));
    });

    // Generic cards / tiles that should reveal as a stagger when their
    // parent section enters the viewport
    function stagger(parentSel, childSel, stepMs) {
      document.querySelectorAll(parentSel).forEach(parent => {
        parent.classList.add('ao-watch');
        parent.querySelectorAll(childSel).forEach((child, i) => {
          child.classList.add('reveal');
          child.style.setProperty('--ao-delay', (i * stepMs) + 'ms');
        });
      });
    }

    stagger('.ao-features-row', '.ao-feature-card', 90);
    stagger('.ao-surfaces-grid', '.ao-surface', 80);
    stagger('.ao-shop-grid', '.ao-shop-card', 100);
    stagger('.ao-reviews-grid', '.ao-review', 110);
    stagger('.ao-blog-grid', '.ao-blog-card', 100);

    // Section headers (eyebrow + h2 + lede) reveal as a group when section enters
    const headerSelectors = [
      '.ao-section-pad .ao-section-inner > .section-eyebrow',
      '.ao-section-pad .ao-section-inner > .ao-section-title-h2',
      '.ao-section-pad .ao-section-inner > .ao-section-lede',
      '.ao-suspects-head',
      '.ao-surfaces-head',
      '.ao-shop-head',
      '.ao-reviews-head',
      '.ao-pdp-benefits-section .ao-section-inner > .section-eyebrow',
      '.ao-pdp-benefits-section .ao-section-inner > .ao-pdp-h2',
    ];
    headerSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.classList.add('reveal');
      });
    });
  }

  function setupIntersection() {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.classList.add('is-in');
        // Children with .reveal trigger via the parent section having is-in
        el.querySelectorAll('.reveal').forEach(child => child.classList.add('is-in'));
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    document.querySelectorAll('.ao-watch').forEach(el => io.observe(el));
    // Also observe any orphan .reveal elements not under .ao-watch
    document.querySelectorAll('.reveal').forEach(el => {
      // Only observe if no parent .ao-watch wraps it
      if (!el.closest('.ao-watch')) io.observe(el);
    });
  }

  function setupNav() {
    const nav = document.querySelector('.ao-nav');
    if (!nav) return;
    function onScroll() {
      if (window.scrollY > 60) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    wrapHeroWords();
    autoDecorate();
    setupIntersection();
    setupNav();
    triggerHero();
  }

  // React rendering may finish after DOMContentLoaded — wait a tick
  function start() {
    if (document.querySelector('.ao-hero-h1') || document.querySelector('.ao-cart-hero') || document.querySelector('.ao-blog-hero') || document.querySelector('.ao-contact-hero')) {
      init();
    } else {
      // Poll briefly for React render to finish
      let tries = 0;
      const id = setInterval(() => {
        tries += 1;
        if (document.querySelector('.ao-hero-h1') || document.querySelector('.ao-cart-hero') || document.querySelector('.ao-blog-hero') || document.querySelector('.ao-contact-hero') || tries > 40) {
          clearInterval(id);
          init();
        }
      }, 80);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
